import { type ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

export function GuaranteesPageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <LoadingRegion label={translate('loading_aria_label')} className="min-h-full">
      <View.Root>
        <View.Header>
          <Skeleton variant="text" width={220} height={32} />
        </View.Header>
        <View.Body>
          <div className="flex flex-col gap-30">
            <Skeleton variant="text" width={160} height={24} />
            <Skeleton variant="block" height={144} />
          </div>
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
